import { render } from "./organizationContactInfoModal.vue?vue&type=template&id=1a2694cf&ts=true"
import script from "./organizationContactInfoModal.ts?vue&type=script&lang=ts"
export * from "./organizationContactInfoModal.ts?vue&type=script&lang=ts"

import "./organizationContactInfoModal.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__